import { useState } from "react";
import Modal from "../../components/Modal";
import Topbar from "../../components/Topbar";
import api from "../../services/api";
import { useEffect } from "react";

const SETORES = [
  { key: "TODOS",          label: "Todos" },
  { key: "PRODUCAO",       label: "Producao" },
  { key: "ADMINISTRATIVO", label: "Administrativo" },
  { key: "VENDAS",         label: "Vendas" },
  { key: "FINANCEIRO",     label: "Financeiro" },
];
const STATUS_BADGE = { ATIVO:"badge-green", INATIVO:"badge-gray", FERIAS:"badge-blue", AFASTADO:"badge-amber" };
const VAZIO = {
  nome:"", cpf:"", rg:"", data_nascimento:"", telefone:"", email:"", endereco:"",
  tipo:"CLT", setor:"PRODUCAO", cargo:"", data_admissao:"", status:"ATIVO",
  salario_base:"0", vale_transporte:"0", vale_refeicao:"0", outros_beneficios:"0",
  encargo_inss:"20.00", encargo_fgts:"8.00", encargo_ferias:"11.11",
  encargo_decimo:"8.33", encargo_outros:"0",
  horas_dia:"8", dias_semana:"5", valor_hora_freelancer:"0", observacoes:""
};
const fmt  = v => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
const fmt4 = v => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:4});

function LinhaFuncionario({f, onEditar, onExcluir}){
  const [open, setOpen] = useState(false);
  return(<>
    <tr className="tr-expandable" onClick={()=>setOpen(o=>!o)}>
      <td>
        <strong>{f.nome}</strong>
        {f.cpf&&<div className="fs-11 text-muted">{f.cpf}</div>}
      </td>
      <td>{f.cargo}</td>
      <td><span className="badge badge-gray">{f.tipo_display}</span></td>
      <td><span className="badge badge-blue">{f.setor_display}</span></td>
      <td>R$ {fmt(f.salario_base)}</td>
      <td className="text-blue fw-500">R$ {fmt4(f.custo_hora)}/h</td>
      <td><span className={"badge "+(STATUS_BADGE[f.status]||"badge-gray")}>{f.status_display}</span></td>
      <td className="td-r"><i className={"ti ti-chevron-"+(open?"up":"down")} style={{fontSize:14,color:"var(--z-text-muted)"}}/></td>
    </tr>
    {open&&(
      <tr className="tr-dropdown">
        <td colSpan={8}>
          <div className="dropdown-content">
            <div className="dropdown-row">
              <div className="dropdown-box">
                <div className="dropdown-section">Dados Profissionais</div>
                <div className="detail-row"><span className="detail-label">Cargo</span><span className="detail-value">{f.cargo}</span></div>
                <div className="detail-row"><span className="detail-label">Tipo</span><span className="detail-value">{f.tipo_display}</span></div>
                <div className="detail-row"><span className="detail-label">Setor</span><span className="detail-value">{f.setor_display}</span></div>
                <div className="detail-row"><span className="detail-label">Status</span><span className="detail-value"><span className={"badge "+(STATUS_BADGE[f.status]||"badge-gray")}>{f.status_display}</span></span></div>
                {f.data_admissao&&<div className="detail-row"><span className="detail-label">Admissao</span><span className="detail-value">{new Date(f.data_admissao).toLocaleDateString("pt-BR")}</span></div>}
                <div className="detail-row"><span className="detail-label">Jornada</span><span className="detail-value">{f.horas_dia}h/dia | {f.dias_semana}x/sem</span></div>
              </div>
              <div className="dropdown-box">
                <div className="dropdown-section">Custo</div>
                <div className="detail-row"><span className="detail-label">Salario base</span><span className="detail-value">R$ {fmt(f.salario_base)}</span></div>
                <div className="detail-row"><span className="detail-label">VT</span><span className="detail-value">R$ {fmt(f.vale_transporte)}</span></div>
                <div className="detail-row"><span className="detail-label">VR</span><span className="detail-value">R$ {fmt(f.vale_refeicao)}</span></div>
                <div className="detail-row"><span className="detail-label">INSS Patronal</span><span className="detail-value">{f.encargo_inss}%</span></div>
                <div className="detail-row"><span className="detail-label">FGTS</span><span className="detail-value">{f.encargo_fgts}%</span></div>
                <div className="detail-row"><span className="detail-label">Ferias+1/3</span><span className="detail-value">{f.encargo_ferias}%</span></div>
                <div className="detail-row"><span className="detail-label">13o</span><span className="detail-value">{f.encargo_decimo}%</span></div>
                <div className="dropdown-total"><span>Custo/hora</span><span>R$ {fmt4(f.custo_hora)}</span></div>
              </div>
              {(f.telefone||f.email)&&(
                <div className="dropdown-box">
                  <div className="dropdown-section">Contato</div>
                  {f.telefone&&<div className="detail-row"><span className="detail-label">Telefone</span><span className="detail-value">{f.telefone}</span></div>}
                  {f.email&&<div className="detail-row"><span className="detail-label">Email</span><span className="detail-value">{f.email}</span></div>}
                </div>
              )}
            </div>
            <div className="produto-dropdown-acoes">
              <button className="btn btn-secondary" onClick={e=>{e.stopPropagation();onEditar(f);}}>
                <i className="ti ti-edit"/> Editar
              </button>
              <button className="btn btn-danger" onClick={e=>{e.stopPropagation();onExcluir(f.id);}}>
                <i className="ti ti-trash"/> Excluir
              </button>
            </div>
          </div>
        </td>
      </tr>
    )}
  </>);
}

export default function FuncionariosLista(){
  const [funcionarios, setFuncionarios] = useState([]);
  const [busca, setBusca]   = useState("");
  const [setor, setSetor]   = useState("TODOS");
  const [loading, setLoading] = useState(true);
  const [modalForm, setModalForm] = useState(null);
  const [form, setForm]     = useState(VAZIO);
  const [salvando, setSalvando] = useState(false);

  const carregar = () => {
    setLoading(true);
    api.get("/funcionarios/funcionarios/")
      .then(res => setFuncionarios(res.data.results||res.data))
      .catch(()  => setFuncionarios([]))
      .finally(() => setLoading(false));
  };
  useEffect(()=>{carregar();},[]);

  const filtrados = funcionarios
    .filter(f => setor==="TODOS" || f.setor===setor)
    .filter(f => f.nome.toLowerCase().includes(busca.toLowerCase()) || f.cargo.toLowerCase().includes(busca.toLowerCase()));

  const count = key => key==="TODOS" ? funcionarios.length : funcionarios.filter(f=>f.setor===key).length;

  const abrirNovo   = ()  => { setForm(VAZIO); setModalForm("novo"); };
  const abrirEditar = (f) => { setForm({...f}); setModalForm("editar"); };
  const excluir = async id => {
    if(!window.confirm("Excluir este funcionario?")) return;
    await api.delete("/funcionarios/funcionarios/"+id+"/");
    carregar();
  };
  const salvar = async () => {
    setSalvando(true);
    try{
      const fmt = d => { if(!d) return null; const p=d.split("/"); return p.length===3?p[2]+"-"+p[1]+"-"+p[0]:d; };
      const dados = {...form, data_nascimento:fmt(form.data_nascimento)||null, data_admissao:fmt(form.data_admissao)||null};
      if(modalForm==="novo") await api.post("/funcionarios/funcionarios/", dados);
      else await api.put("/funcionarios/funcionarios/"+form.id+"/", dados);
      carregar(); setModalForm(null);
    }catch(e){ alert(e.response?.data ? JSON.stringify(e.response.data) : "Erro ao salvar."); }
    finally{ setSalvando(false); }
  };

  const campo = (label, field, opts={}) => (
    <div className="form-group">
      <label className="form-label">{label}</label>
      {opts.select
        ? <select className="form-select" value={form[field]||""} onChange={e=>setForm(f=>({...f,[field]:e.target.value}))}>{opts.options.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}</select>
        : <input className="form-input" value={form[field]||""} onChange={e=>setForm(f=>({...f,[field]:e.target.value}))} placeholder={opts.placeholder||""} type={opts.type||"text"}/>
      }
    </div>
  );

  const custoMensal = () => {
    const sal = parseFloat(form.salario_base||0);
    const enc = sal*(parseFloat(form.encargo_inss||0)+parseFloat(form.encargo_fgts||0)+parseFloat(form.encargo_ferias||0)+parseFloat(form.encargo_decimo||0)+parseFloat(form.encargo_outros||0))/100;
    return sal+enc+parseFloat(form.vale_transporte||0)+parseFloat(form.vale_refeicao||0)+parseFloat(form.outros_beneficios||0);
  };
  const horasMes  = () => parseFloat(form.horas_dia||0)*parseFloat(form.dias_semana||0)*4.33;
  const custoHora = () => horasMes()>0 ? custoMensal()/horasMes() : 0;

  const footer = (<>
    <button className="btn btn-secondary" onClick={()=>setModalForm(null)}>Cancelar</button>
    <button className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando?"Salvando...":"Salvar"}</button>
  </>);

  return(<>
    <Topbar title="Funcionarios"/>
    <div className="erp-content">
      <div className="page-toolbar">
        <button className="btn btn-primary" onClick={abrirNovo}><i className="ti ti-plus"/> Novo funcionario</button>
        <input className="form-input" style={{width:240}} placeholder="Buscar..." value={busca} onChange={e=>setBusca(e.target.value)}/>
      </div>
      <div className="abas-wrapper mb-16">
        <div className="abas">
          {SETORES.map(s=>(
            <button key={s.key} className={"aba"+(setor===s.key?" aba-ativa":"")} onClick={()=>setSetor(s.key)}>
              {s.label} <span className="aba-count">{count(s.key)}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="card">
        <div className="table-wrapper">
          {loading ? <div className="table-empty">Carregando...</div> :
           filtrados.length===0 ? <div className="table-empty">Nenhum funcionario encontrado.</div> : (
            <table>
              <thead><tr>
                <th>Nome</th><th>Cargo</th><th>Tipo</th><th>Setor</th>
                <th>Salario Base</th><th>Custo/Hora</th><th>Status</th><th></th>
              </tr></thead>
              <tbody>
                {filtrados.map(f=><LinhaFuncionario key={f.id} f={f} onEditar={abrirEditar} onExcluir={excluir}/>)}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>

    {modalForm&&(
      <Modal title={modalForm==="novo"?"Novo funcionario":"Editar funcionario"} onClose={()=>setModalForm(null)} size="lg" footer={footer}>
        <div className="form-grid">
          {campo("Nome completo","nome",{placeholder:"Nome do funcionario"})}
          {campo("Cargo","cargo",{placeholder:"Ex: Operador de Maquina"})}
          {campo("Tipo","tipo",{select:true,options:[{v:"CLT",l:"CLT"},{v:"FREELANCER",l:"Freelancer"}]})}
          {campo("Setor","setor",{select:true,options:[{v:"PRODUCAO",l:"Producao"},{v:"ADMINISTRATIVO",l:"Administrativo"},{v:"VENDAS",l:"Vendas"},{v:"FINANCEIRO",l:"Financeiro"}]})}
          {campo("Status","status",{select:true,options:[{v:"ATIVO",l:"Ativo"},{v:"INATIVO",l:"Inativo"},{v:"FERIAS",l:"Ferias"},{v:"AFASTADO",l:"Afastado"}]})}
          {campo("CPF","cpf",{placeholder:"000.000.000-00"})}
          {campo("Telefone","telefone")}
          {campo("Email","email",{type:"email"})}
          {campo("Data admissao","data_admissao",{type:"date"})}
        </div>
        <div className="form-section">Remuneracao</div>
        {form.tipo==="FREELANCER" ? (
          <div className="form-grid">{campo("Valor por hora (R$)","valor_hora_freelancer",{type:"number"})}</div>
        ) : (<>
          <div className="form-grid">
            {campo("Salario base","salario_base",{type:"number"})}
            {campo("Vale Transporte","vale_transporte",{type:"number"})}
            {campo("Vale Refeicao","vale_refeicao",{type:"number"})}
            {campo("Outros beneficios","outros_beneficios",{type:"number"})}
          </div>
          <div className="form-section">Encargos</div>
          <div className="form-grid">
            {campo("INSS Patronal (%)","encargo_inss",{type:"number"})}
            {campo("FGTS (%)","encargo_fgts",{type:"number"})}
            {campo("Ferias+1/3 (%)","encargo_ferias",{type:"number"})}
            {campo("13o Salario (%)","encargo_decimo",{type:"number"})}
            {campo("Outros encargos (%)","encargo_outros",{type:"number"})}
          </div>
        </>)}
        <div className="form-section">Jornada</div>
        <div className="form-grid">
          {campo("Horas por dia","horas_dia",{type:"number"})}
          {campo("Dias por semana","dias_semana",{type:"number"})}
        </div>
        {parseFloat(form.salario_base)>0&&(
          <div className="badge-blue" style={{padding:"12px 16px",borderRadius:"var(--z-radius-md)",marginTop:16}}>
            <div style={{fontSize:12,marginBottom:4}}>Preview do custo calculado:</div>
            <div className="dropdown-row" style={{gap:24,fontSize:13}}>
              <span>Custo mensal: <strong>R$ {fmt(custoMensal())}</strong></span>
              <span>Horas/mes: <strong>{horasMes().toFixed(0)}h</strong></span>
              <span><strong>Custo/hora: R$ {fmt4(custoHora())}</strong></span>
            </div>
          </div>
        )}
        <div className="form-section">Observacoes</div>
        <div className="form-group">
          <textarea className="form-input" rows={2} value={form.observacoes||""} onChange={e=>setForm(f=>({...f,observacoes:e.target.value}))}/>
        </div>
      </Modal>
    )}
  </>);
}

